<template>
  <div class="navbar">
    <div class="mobile-nav">
      <div id="menuToggle">
        <input type="checkbox" />

        <!-- collapse button -->
        <span></span>
        <span></span>
        <span></span>

        <!-- menu items -->
        <ul id="menu">
          <li>
            <router-link @click.native="moveToSection('about')" to>About</router-link>
          </li>
          <li>
            <router-link @click.native="moveToSection('skills')" to>Skills & Services</router-link>
          </li>
          <li>
            <router-link @click.native="moveToSection('projects')" to>Projects</router-link>
          </li>
          <li>
            <router-link @click.native="moveToSection('articles')" to>Articles</router-link>
          </li>
          <li>
            <router-link @click.native="moveToSection('contact')" to>Contact</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileNavbar",
  methods: {
    moveToSection(section) {
      let header = document.querySelector(".home-header").clientHeight;
      let about = document.querySelector("#about").clientHeight;
      let skills = document.querySelector("#skills").clientHeight;
      let projects = document.querySelector("#projects").clientHeight;
      let articles = document.querySelector("#articles").clientHeight;

      let top = 0;

      if (section === "about") {
        top = header;
      }
      if (section === "skills") {
        top = about + header;
      }
      if (section === "projects") {
        top = header + about + skills;
      }
      if (section === "articles") {
        top = header + about + skills + projects;
      }
      if (section === "contact") {
        top = header + about + skills + projects + articles;
      }

      window.scroll({
        top,
        left: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>
